import { createSelector } from 'reselect';
import { lovesSelector } from 'selectors/loves/lovesSelector';

const initializedCurrentLovesSelector = createSelector(lovesSelector, ({ currentLovesSkuDetails, currentLovesIsInitialized }) => {
    return {
        currentLoves: currentLovesSkuDetails,
        currentLovesIsInitialized
    };
});

export default initializedCurrentLovesSelector;
